<template>
<div class="left-bar">
	<div class="top">
    <div class="logoArea">
      <img src="../../../../public/images/logo2.png" alt=""> 
    </div>
    ERP扩展
	</div>
  <!-- active-text-color="#4dbcff" -->
  <el-menu
    background-color="#2273c7"
    text-color="#eee"
    active-text-color="#fff"
    :default-active="currentMenu"
    :unique-opened="true"
  >
    <dynamic-menu :menuList="sidebarMenu"></dynamic-menu>
  </el-menu>
</div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isCollapse: true,
    };
  },
  created(){
    this.$store.dispatch('sideBarMenu/SET_SIDEBAR_MENU');
  },
  computed: {
    ...mapState("sideBarMenu", ["sidebarMenu", "currentMenu"]),
  },
  watch:{
    currentMenu(){
    }
  },
  methods: {},
  components: {
  },
};
</script>
<style lang="less">
.left-bar {
	width: 200px;
	// background:#0d65b1;
	// background:#2d6dd2;
	background:#2273c7;
  // background: linear-gradient(180deg,#001a77, #37a1c8);
	// background:#0b2048;
	height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  flex-shrink: 0;
  
  .top {
    display: flex;
    justify-content: center;
    /* padding: 20px 0 20px 0; */
    height: 50px;
    min-height: 50px;
    max-height: 50px;
    align-items: center;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    color:#b0c0e6;
    font-size: 18px;
    flex-shrink: 0;
    img { 
      height: 20px;
    }
    .logoArea {
      width: 62px;
      overflow: hidden;
      margin-top: 7px;
    }
  }
}
</style>
